import { Center, Stack, Text } from "@mantine/core";
import { IconCalendarOff } from "@tabler/icons-react";
import dayjs from "dayjs";

/**
 * Copy for the two empty cases: no sessions at all, and — when `day` is given
 * — none on the open day. Filters change the wording in both.
 */
export function emptyStateCopy({ hasActiveFilters, day }) {
  if (!day) {
    return hasActiveFilters
      ? {
          title: "No matching sessions",
          message: "No sessions match your search or location filter.",
        }
      : {
          title: "No sessions yet",
          message: "Create a session and it will show up on the calendar.",
        };
  }

  const label = dayjs(day).format("dddd, MMMM D");
  return hasActiveFilters
    ? {
        title: "No matching sessions",
        message: `No sessions match your search or location filter on ${label}.`,
      }
    : { title: "Nothing scheduled", message: `No sessions on ${label}.` };
}

export default function CalendarEmptyState({ title, message }) {
  return (
    <Center mih={280}>
      <Stack align="center" gap={6}>
        <IconCalendarOff
          size={32}
          color="var(--mantine-color-dimmed)"
          stroke={1.5}
        />
        <Text fw={600}>{title}</Text>
        <Text size="sm" c="dimmed">
          {message}
        </Text>
      </Stack>
    </Center>
  );
}
